// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.groupdetails {
    background-color: #fff;
    border-radius: 6px;
    margin: 20px;
    padding: 17px;

    p {
        font-size: 14px;
        border-bottom: 1px solid #f4f3f3;
        padding: 7px;
    }
}

.groupmember {
    display: flex;
    gap: 10px;
    margin: 10px 0;

    img {
        width: 25px;
        height: 25px;
        border-radius: 50%;
    }
}

.groupmemberprofile {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: var(--brand-primary);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

}

.kyctitle {
    font-size: 24px;
    margin-bottom: 17px;
}

.kycbuttons {
    display: flex;
    justify-content: space-around;

    button {
        width: 45%;
        background-color: var(--brand-primary);
        color: #fff;
        border: none;
        padding: 5px;
        border-radius: 5px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/Groupdetails.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,aAAa;;IAEb;QACI,eAAe;QACf,gCAAgC;QAChC,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;;IAEd;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;;IAE7B;QACI,UAAU;QACV,sCAAsC;QACtC,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,kBAAkB;IACtB;AACJ","sourcesContent":[".groupdetails {\n    background-color: #fff;\n    border-radius: 6px;\n    margin: 20px;\n    padding: 17px;\n\n    p {\n        font-size: 14px;\n        border-bottom: 1px solid #f4f3f3;\n        padding: 7px;\n    }\n}\n\n.groupmember {\n    display: flex;\n    gap: 10px;\n    margin: 10px 0;\n\n    img {\n        width: 25px;\n        height: 25px;\n        border-radius: 50%;\n    }\n}\n\n.groupmemberprofile {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background-color: var(--brand-primary);\n    color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.kyctitle {\n    font-size: 24px;\n    margin-bottom: 17px;\n}\n\n.kycbuttons {\n    display: flex;\n    justify-content: space-around;\n\n    button {\n        width: 45%;\n        background-color: var(--brand-primary);\n        color: #fff;\n        border: none;\n        padding: 5px;\n        border-radius: 5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
